import { useEffect, useRef, useState } from 'react';
import styles from './MonochromeLanding.module.css';
import { 
  FaSyncAlt, FaCheck, FaUser, FaShieldAlt, FaChartLine, FaMobileAlt, 
  FaCalendarAlt, FaUsers, FaBell, FaLock, FaRobot, FaBolt,
  FaWhatsapp, FaEnvelope, FaBars, FaYoutube, FaRocket, FaClock, FaInstagram 
} from 'react-icons/fa';
import { SiPix } from "react-icons/si";

const CyberMonochrome = () => {
  const canvasRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [billingCycle, setBillingCycle] = useState('mensal');
  const [planType, setPlanType] = useState('comWhatsApp'); // 'semWhatsApp' ou 'comWhatsApp'

  // Função auxiliar para calcular preços com desconto
  const calculateDiscountedPrice = (basePrice, discountPercent) => {
    const discounted = basePrice * (1 - discountPercent / 100);
    return Math.round(discounted * 100) / 100;
  };

  const plans = {
    semWhatsApp: {
      mensal: {
        title: "Plano Mensal - Sem WhatsApp",
        discount: "",
        prices: [
          { 
            professionals: 1, 
            price: 79.90, 
            monthly: 79.90,
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "1 usuário",
              "Suporte Cronos",
              "Sem API Oficial do WhatsApp"
            ]
          },
          { 
            professionals: 2, 
            price: 89.90, 
            monthly: 89.90,
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "2 usuários",
              "Suporte Cronos",
              "Sem API Oficial do WhatsApp"
            ]
          },
          { 
            professionals: 3, 
            price: 99.90, 
            monthly: 99.90,
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "3 usuários",
              "Suporte Cronos",
              "Sem API Oficial do WhatsApp"
            ]
          }
        ],
        extra: "+1 Profissional = + R$10,00"
      },
      trimestral: {
        title: "Plano Trimestral - Sem WhatsApp",
        discount: "5% de desconto",
        prices: [
          { 
            professionals: 1, 
            price: calculateDiscountedPrice(79.90 * 3, 5), // 239.70 * 0.95 = 227.72
            monthly: calculateDiscountedPrice(79.90, 5), // 75.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "1 usuário",
              "Suporte Avançado",
              "Sem API Oficial do WhatsApp"
            ]
          },
          { 
            professionals: 2, 
            price: calculateDiscountedPrice(89.90 * 3, 5), // 269.70 * 0.95 = 256.22
            monthly: calculateDiscountedPrice(89.90, 5), // 85.41
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "2 usuários",
              "Suporte Avançado",
              "Sem API Oficial do WhatsApp"
            ]
          },
          { 
            professionals: 3, 
            price: calculateDiscountedPrice(99.90 * 3, 5), // 299.70 * 0.95 = 284.72
            monthly: calculateDiscountedPrice(99.90, 5), // 94.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "3 usuários",
              "Suporte Avançado",
              "Sem API Oficial do WhatsApp"
            ]
          }
        ],
        extra: "Pagamento trimestral"
      },
      semestral: {
        title: "Plano Semestral - Sem WhatsApp",
        discount: "10% de desconto",
        prices: [
          { 
            professionals: 1, 
            price: calculateDiscountedPrice(79.90 * 6, 10), // 479.40 * 0.90 = 431.46
            monthly: calculateDiscountedPrice(79.90, 10), // 71.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "1 usuário",
              "Suporte Prioritário",
              "Sem API Oficial do WhatsApp"
            ]
          },
          { 
            professionals: 2, 
            price: calculateDiscountedPrice(89.90 * 6, 10), // 539.40 * 0.90 = 485.46
            monthly: calculateDiscountedPrice(89.90, 10), // 80.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "2 usuários",
              "Suporte Prioritário",
              "Sem API Oficial do WhatsApp"
            ]
          },
          { 
            professionals: 3, 
            price: calculateDiscountedPrice(99.90 * 6, 10), // 599.40 * 0.90 = 539.46
            monthly: calculateDiscountedPrice(99.90, 10), // 89.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "3 usuários",
              "Suporte Prioritário",
              "Sem API Oficial do WhatsApp"
            ]
          }
        ],
        extra: "Pagamento semestral"
      },
      anual: {
        title: "Plano Anual - Sem WhatsApp",
        discount: "15% de desconto",
        prices: [
          { 
            professionals: 1, 
            price: calculateDiscountedPrice(79.90 * 12, 15), // 958.80 * 0.85 = 814.98
            monthly: calculateDiscountedPrice(79.90, 15), // 67.92
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "1 usuário",
              "Suporte Prioritário",
              "Atualizações gratuitas",
              "Sem API Oficial do WhatsApp"
            ]
          },
          { 
            professionals: 2, 
            price: calculateDiscountedPrice(89.90 * 12, 15), // 1078.80 * 0.85 = 916.98
            monthly: calculateDiscountedPrice(89.90, 15), // 76.42
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "2 usuários",
              "Suporte Prioritário",
              "Atualizações gratuitas",
              "Sem API Oficial do WhatsApp"
            ]
          },
          { 
            professionals: 3, 
            price: calculateDiscountedPrice(99.90 * 12, 15), // 1198.80 * 0.85 = 1018.98
            monthly: calculateDiscountedPrice(99.90, 15), // 84.92
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "3 usuários",
              "Suporte Prioritário",
              "Atualizações gratuitas",
              "Sem API Oficial do WhatsApp"
            ]
          }
        ],
        extra: "Pagamento anual"
      }
    },
    comWhatsApp: {
      mensal: {
        title: "Plano Mensal - Com WhatsApp",
        discount: "",
        prices: [
          { 
            professionals: 1, 
            price: 99.90, 
            monthly: 99.90,
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "1 usuário",
              "Suporte Cronos",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          },
          { 
            professionals: 2, 
            price: 109.90, 
            monthly: 109.90,
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "2 usuários",
              "Suporte Cronos",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          },
          { 
            professionals: 3, 
            price: 119.90, 
            monthly: 119.90,
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "3 usuários",
              "Suporte Cronos",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          }
        ],
        extra: "+1 Profissional = + R$10,00"
      },
      trimestral: {
        title: "Plano Trimestral - Com WhatsApp",
        discount: "5% de desconto",
        prices: [
          { 
            professionals: 1, 
            price: calculateDiscountedPrice(99.90 * 3, 5), // 299.70 * 0.95 = 284.72
            monthly: calculateDiscountedPrice(99.90, 5), // 94.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "1 usuário",
              "Suporte Avançado",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          },
          { 
            professionals: 2, 
            price: calculateDiscountedPrice(109.90 * 3, 5), // 329.70 * 0.95 = 313.22
            monthly: calculateDiscountedPrice(109.90, 5), // 104.41
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "2 usuários",
              "Suporte Avançado",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          },
          { 
            professionals: 3, 
            price: calculateDiscountedPrice(119.90 * 3, 5), // 359.70 * 0.95 = 341.72
            monthly: calculateDiscountedPrice(119.90, 5), // 113.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "3 usuários",
              "Suporte Avançado",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          }
        ],
        extra: "Pagamento trimestral"
      },
      semestral: {
        title: "Plano Semestral - Com WhatsApp",
        discount: "10% de desconto",
        prices: [
          { 
            professionals: 1, 
            price: calculateDiscountedPrice(99.90 * 6, 10), // 599.40 * 0.90 = 539.46
            monthly: calculateDiscountedPrice(99.90, 10), // 89.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "1 usuário",
              "Suporte Prioritário",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          },
          { 
            professionals: 2, 
            price: calculateDiscountedPrice(109.90 * 6, 10), // 659.40 * 0.90 = 593.46
            monthly: calculateDiscountedPrice(109.90, 10), // 98.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "2 usuários",
              "Suporte Prioritário",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          },
          { 
            professionals: 3, 
            price: calculateDiscountedPrice(119.90 * 6, 10), // 719.40 * 0.90 = 647.46
            monthly: calculateDiscountedPrice(119.90, 10), // 107.91
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "3 usuários",
              "Suporte Prioritário",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          }
        ],
        extra: "Pagamento semestral"
      },
      anual: {
        title: "Plano Anual - Com WhatsApp",
        discount: "15% de desconto",
        prices: [
          { 
            professionals: 1, 
            price: calculateDiscountedPrice(99.90 * 12, 15), // 1198.80 * 0.85 = 1018.98
            monthly: calculateDiscountedPrice(99.90, 15), // 84.92
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "1 usuário",
              "Suporte Prioritário",
              "Atualizações gratuitas",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          },
          { 
            professionals: 2, 
            price: calculateDiscountedPrice(109.90 * 12, 15), // 1318.80 * 0.85 = 1120.98
            monthly: calculateDiscountedPrice(109.90, 15), // 93.42
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "2 usuários",
              "Suporte Prioritário",
              "Atualizações gratuitas",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          },
          { 
            professionals: 3, 
            price: calculateDiscountedPrice(119.90 * 12, 15), // 1438.80 * 0.85 = 1222.98
            monthly: calculateDiscountedPrice(119.90, 15), // 101.92
            features: [
              "Gestão completa de agenda",
              "Painel Administrativo",
              "3 usuários",
              "Suporte Prioritário",
              "Atualizações gratuitas",
              "API Oficial do WhatsApp",
              "Lembretes automáticos via WhatsApp"
            ]
          }
        ],
        extra: "Pagamento anual"
      }
    }
  };

  // Resto do código permanece igual...
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    const particles = [];
    const particleCount = 200;
    
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 1.5 + 0.5,
        speedX: (Math.random() - 0.5) * 0.3,
        speedY: (Math.random() - 0.5) * 0.3,
        opacity: Math.random() * 0.5 + 0.1,
        color: Math.random() > 0.9 ? '#de01f5' : 'rgba(0, 0, 0, 0.7)'
      });
    }
    
    const animate = () => {
      ctx.fillStyle = 'rgba(255, 255, 255, 0.25)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      particles.forEach(particle => {
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        
        if (particle.color === '#de01f5') {
          ctx.fillStyle = particle.color;
          ctx.shadowBlur = 10;
          ctx.shadowColor = particle.color;
        } else {
          ctx.fillStyle = particle.color;
          ctx.shadowBlur = 0;
        }
        
        ctx.fill();
        
        particle.x += particle.speedX;
        particle.y += particle.speedY;
        
        if (particle.x < 0 || particle.x > canvas.width) particle.speedX *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.speedY *= -1;
      });
      
      requestAnimationFrame(animate);
    };
    
    animate();
    
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Função para rolar até a seção
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  // Obter plano atual baseado na seleção
  const currentPlan = plans[planType][billingCycle];
  
  return (
    <div className={styles.container}>
      {/* Barra de Navegação Fixa - mantida igual */}
      <nav className={styles.navbar}>
        <div className={styles.navContainer}>
          <img 
            src="/logo_cronos.png" 
            alt="Cronos Agenda" 
            className={styles.navLogo}
          />
          
          {/* Menu Desktop */}
          <div className={styles.navLinks}>
            <button onClick={() => scrollToSection('inicio')}>Início</button>
            <button onClick={() => scrollToSection('sobre')}>Sobre</button>
            <button onClick={() => scrollToSection('funcoes')}>Funções</button>
            <button onClick={() => scrollToSection('planos')}>Planos</button>
            <button 
              className={styles.navCta}
              onClick={() => scrollToSection('seja-cronos')}
            >
              Seja Cronos!
            </button>
          </div>
          
          {/* Menu Mobile */}
          <button 
            className={styles.menuButton}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <FaBars />
          </button>
        </div>
        
        {/* Menu Mobile Dropdown */}
        <div className={`${styles.mobileMenu} ${menuOpen ? styles.open : ''}`}>
          <button onClick={() => scrollToSection('inicio')}>Início</button>
          <button onClick={() => scrollToSection('sobre')}>Sobre</button>
          <button onClick={() => scrollToSection('funcoes')}>Funções</button>
          <button onClick={() => scrollToSection('planos')}>Planos</button>
          <button onClick={() => scrollToSection('seja-cronos')}>Seja Cronos!</button>
        </div>
      </nav>
      <canvas ref={canvasRef} className={styles.canvas} />
      
      <div className={styles.content}>
        {/* Logo e Header (mantido igual) */}     
        <div id="inicio" className={styles.header}>
          <h1 className={styles.title}>
            <span className={styles.titleLine}>CRONOS</span>
            <span className={styles.titleLine}>AGENDA</span>
          </h1>
          
          <div className={styles.divider} />
          
          <p className={styles.subtitle}>
            O FUTURO EM <span className={styles.neonText}>GESTÃO DO TEMPO</span>
          </p>
        </div>

        {/* Seção Sobre - VERSÃO MINIMALISTA */}
        <div id="sobre" className={styles.aboutSection}>
          <div className={styles.aboutContainer}>
            <h2 className={styles.sectionTitle}>SOBRE A CRONOS AGENDA</h2>
            <div className={styles.aboutBox}>
              <p className={styles.editableText}>
                A <strong>Cronos Agenda</strong> revoluciona a gestão do tempo com tecnologia inteligente e um design intuitivo. 
                Nossa plataforma combina simplicidade e sofisticação para proporcionar uma experiência fluida tanto para você quanto para seus clientes. 
                Com soluções personalizadas para profissionais exigentes, ajudamos a otimizar seus agendamentos e aumentar sua produtividade, transformando a forma como você gerencia seu negócio.
              </p>
            </div>
          </div>
        </div>

        {/* Nova Seção META Verified */}
        <div className={styles.metaSection}>
          <div className={styles.metaContainer}>
            {/* Background especial */}
            <div className={styles.metaBackground}></div>
            
            <div className={styles.metaContent}>
              {/* Header da seção */}
              <div className={styles.metaHeader}>
                <div className={styles.metaBadge}>
                  <span>✓ VERIFICADO</span>
                </div>
                <h2 className={styles.metaTitle}>
                  Provedor Oficial de Tecnologia <span className={styles.metaHighlight}>META</span>
                </h2>
                <p className={styles.metaSubtitle}>
                  Oferecemos a <strong>API Oficial do WhatsApp</strong> com selo de qualidade e segurança META
                </p>
              </div>

              {/* Grid de benefícios */}
              <div className={styles.metaGrid}>
                {/* Card 1 - Verificação */}
                <div className={styles.metaCard}>
                  <div className={styles.metaIcon}>
                    <FaShieldAlt />
                  </div>
                  <h3>Verificação META</h3>
                  <p>Somos provedores verificados e autorizados pela META, garantindo total conformidade e segurança.</p>
                  <div className={styles.metaFeatureList}>
                    <span>✓ Certificação oficial</span>
                    <span>✓ Conformidade total</span>
                    <span>✓ Segurança garantida</span>
                  </div>
                </div>

                {/* Card 2 - API Oficial */}
                <div className={styles.metaCard}>
                  <div className={styles.metaIcon}>
                    <FaWhatsapp />
                  </div>
                  <h3>API Oficial WhatsApp</h3>
                  <p>Integração direta com a API oficial do WhatsApp Business, sem intermediários ou soluções alternativas.</p>
                  <div className={styles.metaFeatureList}>
                    <span>✓ API Oficial WhatsApp</span>
                    <span>✓ Mensagens ilimitadas</span>
                    <span>✓ Alta confiabilidade</span>
                  </div>
                </div>

                {/* Card 3 - Vantagens */}
                <div className={styles.metaCard}>
                  <div className={styles.metaIcon}>
                    <FaBolt />
                  </div>
                  <h3>Vantagens Exclusivas</h3>
                  <p>Acesso a recursos premium e suporte prioritário por sermemos parceiros oficiais META.</p>
                  <div className={styles.metaFeatureList}>
                    <span>✓ Suporte prioritário</span>
                    <span>✓ Atualizações constantes</span>
                    <span>✓ Recursos exclusivos</span>
                  </div>
                </div>
              </div>

              {/* Selos e certificações */}
              <div className={styles.metaSeals}>
                <div className={styles.sealItem}>
                  <div className={styles.sealIcon}>✓</div>
                  <div className={styles.sealText}>
                    <strong>Provedor Verificado META</strong>
                    <span>Certificação oficial</span>
                  </div>
                </div>
                <div className={styles.sealItem}>
                  <div className={styles.sealIcon}>⚡</div>
                  <div className={styles.sealText}>
                    <strong>API Oficial WhatsApp</strong>
                    <span>Integração direta</span>
                  </div>
                </div>
                <div className={styles.sealItem}>
                  <div className={styles.sealIcon}>🔒</div>
                  <div className={styles.sealText}>
                    <strong>Segurança Máxima</strong>
                    <span>Dados protegidos</span>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className={styles.metaCta}>
                <p>
                  <strong>Experimente a diferença de trabalhar com tecnologia oficial!</strong><br />
                  Garanta a melhor experiência para seus clientes com nossa solução verificada.
                </p>
                <button 
                  onClick={() => scrollToSection('planos')}
                  className={styles.metaCtaButton}
                >
                  VER PLANOS COM WHATSAPP
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Seção de Destaques (3 quadrados) - VERSÃO ATUALIZADA */}
        <div className={styles.highlights}>
          <div className={styles.highlightsHeader}>
            <h2 className={styles.sectionTitle}>POR QUE ESCOLHER A CRONOS?</h2>
            <p>Recursos pensados para otimizar seu tempo e aumentar sua produtividade</p>
          </div>
          
          <div className={styles.highlightsGrid}>
            <div className={styles.highlightCard}>
              <div className={styles.highlightIconContainer}>
                <FaRobot className={styles.highlightIcon} />
                <div className={styles.highlightPulse}></div>
              </div>
              <h3>Automação Inteligente</h3>
              <p>Menos trabalho manual, mais eficiência no seu dia a dia com automações que simplificam processos repetitivos</p>
              <div className={styles.highlightHover}>
                <span>+ Produtividade</span>
              </div>
            </div>
            
            <div className={styles.highlightCard}>
              <div className={styles.highlightIconContainer}>
                <FaBolt className={styles.highlightIcon} />
                <div className={styles.highlightPulse}></div>
              </div>
              <h3>Facilidade Total</h3>
              <p>Interface intuitiva que permite gerenciar tudo de forma simples e rápida, sem complicações</p>
              <div className={styles.highlightHover}>
                <span>+ Simplicidade</span>
              </div>
            </div>
            
            <div className={styles.highlightCard}>
              <div className={styles.highlightIconContainer}>
                <FaChartLine className={styles.highlightIcon} />
                <div className={styles.highlightPulse}></div>
              </div>
              <h3>Análises Avançadas</h3>
              <p>Relatórios completos e insights valiosos para tomar decisões mais inteligentes sobre seu negócio</p>
              <div className={styles.highlightHover}>
                <span>+ Insights</span>
              </div>
            </div>
          </div>
        </div>

        {/* Nova Seção de Funcionalidades - VERSÃO SIMPLIFICADA */}
        <div id="funcoes" className={styles.featuresSection}>
          <div className={styles.featuresHeader}>
            <h2 className={styles.sectionTitle}>FUNCIONALIDADES CRONOS AGENDA</h2>
            <p>Descubra todas as ferramentas que vão revolucionar sua gestão de tempo</p>
          </div>
          
          <div className={styles.featuresGrid}>
            {/* Linha 1 */}
            <div className={styles.featureItem}>
              <div className={styles.featureIconContainer}>
                <FaMobileAlt className={styles.featureIcon} />
                <div className={styles.featureGlow}></div>
              </div>
              <h3>Aplicação Web</h3>
              <p className={styles.featureDescription}>Acesse de qualquer dispositivo, sem necessidade de instalação</p>
              <span className={styles.featureBenefit}>+ Conveniência</span>
            </div>
            
            <div className={styles.featureItem}>
              <div className={styles.featureIconContainer}>
                <FaCalendarAlt className={styles.featureIcon} />
                <div className={styles.featureGlow}></div>
              </div>
              <h3>Agendamento Simplificado</h3>
              <p className={styles.featureDescription}>Interface intuitiva para agendamentos rápidos e eficientes</p>
              <span className={styles.featureBenefit}>+ Organização</span>
            </div>
            
            <div className={styles.featureItem}>
              <div className={styles.featureIconContainer}>
                <FaUsers className={styles.featureIcon} />
                <div className={styles.featureGlow}></div>
              </div>
              <h3>Gestão de Equipes</h3>
              <p className={styles.featureDescription}>Controle múltiplos profissionais simultaneamente</p>
              <span className={styles.featureBenefit}>+ Controle</span>
            </div>
            
            <div className={styles.featureItem}>
              <div className={styles.featureIconContainer}>
                <FaBell className={styles.featureIcon} />
                <div className={styles.featureGlow}></div>
              </div>
              <h3>Lembretes Automáticos</h3>
              <p className={styles.featureDescription}>Notificações inteligentes para reduzir faltas</p>
              <span className={styles.featureBenefit}>+ Pontualidade</span>
            </div>

            {/* Linha 2 - mantenha a mesma estrutura para os outros 4 */}
            <div className={styles.featureItem}>
              <div className={styles.featureIconContainer}>
                <FaLock className={styles.featureIcon} />
                <div className={styles.featureGlow}></div>
              </div>
              <h3>Controle Total</h3>
              <p className={styles.featureDescription}>Administre todos os aspectos do seu negócio</p>
              <span className={styles.featureBenefit}>+ Poder</span>
            </div>
            
            <div className={styles.featureItem}>
              <div className={styles.featureIconContainer}>
                <FaSyncAlt className={styles.featureIcon} />
                <div className={styles.featureGlow}></div>
              </div>
              <h3>Eficiência Máxima</h3>
              <p className={styles.featureDescription}>Processos otimizados e automatizados</p>
              <span className={styles.featureBenefit}>+ Velocidade</span>
            </div>
            
            <div className={styles.featureItem}>
              <div className={styles.featureIconContainer}>
                <FaChartLine className={styles.featureIcon} />
                <div className={styles.featureGlow}></div>
              </div>
              <h3>Relatórios Detalhados</h3>
              <p className={styles.featureDescription}>Insights valiosos sobre seu desempenho</p>
              <span className={styles.featureBenefit}>+ Insights</span>
            </div>
            
            <div className={styles.featureItem}>
              <div className={styles.featureIconContainer}>
                <FaShieldAlt className={styles.featureIcon} />
                <div className={styles.featureGlow}></div>
              </div>
              <h3>Painel Seguro</h3>
              <p className={styles.featureDescription}>Proteção máxima para seus dados</p>
              <span className={styles.featureBenefit}>+ Segurança</span>
            </div>
          </div>
        </div>

        
        {/* Nova seção: Pagamento Antecipado Online */}
        <section className={styles.paymentSection}>
          <div className={styles.paymentContainer}>
            <div className={styles.paymentHeader}>
              <span className={styles.paymentBadge}>
                <FaBolt />
                NOVA FUNCIONALIDADE
              </span>

              <h2 className={styles.paymentTitle}>
                Seu horário reservado.
                <br />
                <span>Mais controle para o seu negócio.</span>
              </h2>

              <p className={styles.paymentSubtitle}>
                Com o pagamento antecipado online da Cronos Agenda,
                você pode receber uma parte ou o valor total do serviço
                antes do atendimento, diretamente pelo agendamento.
              </p>
            </div>

            <div className={styles.paymentShowcase}>
              <div className={styles.paymentMainCard}>
                <div className={styles.paymentCardTop}>
                  <div className={styles.paymentIconBox}>
                    <FaLock />
                  </div>
                  <span className={styles.paymentStatus}>
                    MAIS CONTROLE
                  </span>
                </div>

                <h3>Você define as regras.</h3>
                <p>
                  Configure como e quando seus clientes devem pagar,
                  de acordo com a rotina do seu estabelecimento.
                </p>

                <div className={styles.paymentProgress}>
                  <div className={styles.paymentProgressHeader}>
                    <span>Percentual antecipado</span>
                    <strong>De 10% a 100%</strong>
                  </div>

                  <div className={styles.paymentPercentages}>
                    {[10, 25, 30, 50, 100].map((percentual) => (
                      <span
                        key={percentual}
                        className={`${styles.paymentPercentage} ${
                          percentual === 50 ? styles.paymentPercentageActive : ""
                        }`}
                      >
                        {percentual}%
                      </span>
                    ))}
                  </div>

                  <div className={styles.paymentProgressTrack}>
                    <span />
                  </div>

                  <div className={styles.paymentProgressLabels}>
                    <span>Pagamento parcial</span>
                    <span>Pagamento integral</span>
                  </div>
                </div>

                <div className={styles.paymentPixInfo}>
                  <div className={styles.paymentPixIcon}>
                    <SiPix />
                  </div>

                  <div>
                    <strong>Pagamento via Pix</strong>
                    <span>Praticidade e segurança pelo Mercado Pago</span>
                  </div>

                  <FaCheck className={styles.paymentCheck} />
                </div>
              </div>

              <div className={styles.paymentBenefits}>
                <article className={styles.paymentBenefit}>
                  <div className={styles.paymentBenefitIcon}>
                    <FaCalendarAlt />
                  </div>
                  <div>
                    <h3>Você escolhe os serviços</h3>
                    <p>
                      Aplique o pagamento antecipado a todos os serviços
                      ou somente aos que selecionar.
                    </p>
                  </div>
                </article>

                <article className={styles.paymentBenefit}>
                  <div className={styles.paymentBenefitIcon}>
                    <FaClock />
                  </div>
                  <div>
                    <h3>Reserva temporária do horário</h3>
                    <p>
                      Enquanto o pagamento é aguardado, o horário fica
                      reservado temporariamente para evitar conflitos
                      durante a finalização.
                    </p>
                  </div>
                </article>

                <article className={styles.paymentBenefit}>
                  <div className={styles.paymentBenefitIcon}>
                    <FaChartLine />
                  </div>
                  <div>
                    <h3>Mais previsibilidade</h3>
                    <p>
                      Tenha mais controle sobre os valores antecipados
                      e sobre a organização da sua agenda.
                    </p>
                  </div>
                </article>
              </div>
            </div>

            <div className={styles.paymentFooter}>
              <p>
                <strong>Você no controle.</strong>
                {' '}Configure o pagamento de acordo com o seu negócio.
              </p>

              <button
                type="button"
                className={styles.paymentCta}
                onClick={() => scrollToSection('planos')}
              >
                CONHECER OS PLANOS
                <FaRocket />
              </button>
            </div>
          </div>
        </section>

        {/* SEÇÃO DE PLANOS ATUALIZADA */}
        <div id="planos" className={styles.pricingSection}>
          <h2 className={styles.sectionTitle}>PLANOS & PREÇOS</h2>
          
          {/* Seletor de Tipo de Plano - NOVA VERSÃO */}
          <div className={styles.planTypeSelector}>
            <div className={styles.planTypeHeader}>
              <h3>Escolha seu plano ideal</h3>
              <p>Selecione a opção que melhor atende suas necessidades</p>
            </div>
            
            <div className={styles.planTypeCards}>
              <div 
                className={`${styles.planTypeCard} ${planType === 'semWhatsApp' ? styles.active : ''}`}
                onClick={() => setPlanType('semWhatsApp')}
              >
                <div className={styles.planTypeIcon}>
                  <FaCalendarAlt />
                </div>
                <div className={styles.planTypeContent}>
                  <h4>Plano Essencial</h4>
                  <p>Gestão completa de agenda sem WhatsApp</p>
                  <div className={styles.planTypePrice}>
                    <span className={styles.startingFrom}>A partir de</span>
                    <span className={styles.price}>R$ 79,90/mês</span>
                  </div>
                </div>
                <div className={styles.planTypeBadge}>
                  {planType === 'semWhatsApp' ? 'Selecionado' : 'Básico'}
                </div>
              </div>
              
              <div 
                className={`${styles.planTypeCard} ${planType === 'comWhatsApp' ? styles.active : ''}`}
                onClick={() => setPlanType('comWhatsApp')}
              >
                <div className={styles.planTypeIcon}>
                  <FaWhatsapp />
                </div>
                <div className={styles.planTypeContent}>
                  <h4>Plano Premium</h4>
                  <p>Com API Oficial do WhatsApp incluída</p>
                  <div className={styles.planTypePrice}>
                    <span className={styles.startingFrom}>A partir de</span>
                    <span className={styles.price}>R$ 99,90/mês</span>
                  </div>
                </div>
                <div className={styles.planTypeBadge}>
                  {planType === 'comWhatsApp' ? 'Selecionado' : 'Popular'}
                </div>
              </div>
            </div>
          </div>
          
          {/* Seletor de Periodicidade */}
          <div className={styles.billingSelector}>
            <div className={styles.billingHeader}>
              <h4>Escolha a periodicidade</h4>
              <p>Economize mais com planos de longo prazo</p>
            </div>
            
            <div className={styles.billingToggle}>
              {['mensal', 'trimestral', 'semestral', 'anual'].map((cycle) => (
                <div key={cycle} className={styles.toggleWrapper}>
                  <button
                    className={`${styles.toggleButton} ${billingCycle === cycle ? styles.active : ''}`}
                    onClick={() => setBillingCycle(cycle)}
                  >
                    {cycle.charAt(0).toUpperCase() + cycle.slice(1)}
                  </button>
                  {plans[planType][cycle].discount && (
                    <span className={styles.discountBadge}>{plans[planType][cycle].discount}</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Grid de Preços - NOVA VERSÃO */}
          <div className={styles.pricingGrid}>
            {currentPlan.prices.map((plan, index) => (
              <div key={index} className={styles.pricingCard}>
                {/* Destaque para plano popular */}
                {plan.professionals === 1 && (
                  <div className={styles.popularBadge}>Mais Popular</div>
                )}
                
                <div className={styles.pricingHeader}>
                  <div className={styles.professionalInfo}>
                    {plan.professionals === 1 ? (
                      <FaUser className={styles.pricingIcon} />
                    ) : (
                      <FaUsers className={styles.pricingIcon} />
                    )}
                    <h3>{plan.professionals} Profissional{plan.professionals > 1 ? 's' : ''}</h3>
                  </div>
                  
                  <div className={styles.priceContainer}>
                    <div className={styles.priceMain}>
                      R$ {plan.price.toFixed(2).replace('.', ',')}
                    </div>
                    <div className={styles.priceMonthly}>
                      Equivale a <strong>R$ {plan.monthly.toFixed(2).replace('.', ',')}/mês</strong>
                    </div>
                  </div>
                </div>
                
                <div className={styles.featuresContainer}>
                  <h4 className={styles.featuresTitle}>O que está incluído:</h4>
                  <ul className={styles.featuresList}>
                    {plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>
                        <div className={styles.featureCheck}>
                          <FaCheck />
                        </div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className={styles.pricingActions}>
                  <button 
                    onClick={() => scrollToSection('rodape')} 
                    className={styles.priceButton}
                  >
                    <FaWhatsapp className={styles.buttonIcon} />
                    FALE CONOSCO
                  </button>
                  
                  <div className={styles.priceExtra}>
                    {currentPlan.extra}
                  </div>
                </div>
                
                {/* Efeito de brilho no hover */}
                <div className={styles.cardGlow}></div>
              </div>
            ))}
          </div>
        </div>

        {/* Seção Seja Cronos - VERSÃO ATUALIZADA */}
        <div id="seja-cronos" className={styles.beCronosSection}>
          <div className={styles.beCronosContainer}>
            {/* Efeito de fundo especial */}
            <div className={styles.beCronosBg}></div>
            
            {/* Conteúdo principal */}
            <div className={styles.beCronosContent}>
              <div className={styles.beCronosHeader}>
                <h2 className={styles.beCronosTitle}>
                  <span className={styles.titlePart}>SEJA</span>
                  <span className={`${styles.titlePart} ${styles.neonText}`}>CRONOS</span>
                </h2>
                <p className={styles.beCronosSubtitle}>
                  Junte-se à revolução na gestão do tempo e transforme sua produtividade
                </p>
              </div>
              
              <div className={styles.beCronosGrid}>
                {/* Card 1 - Destaque */}
                <div className={`${styles.beCronosCard} ${styles.featuredCard}`}>
                  <div className={styles.cardPulse}></div>
                  <div className={styles.featuredBadge}>Destaque</div>
                  <h3>Transforme sua produtividade</h3>
                  <p>
                    Não fique para trás! Junte-se ao time de Profissionais que já estão usando 
                    a Cronos Agenda para otimizar seu tempo e negócios com tecnologia de ponta.
                  </p>
                  <div className={styles.cardStats}>
                    <div className={styles.statItem}>
                      <span className={styles.statNumber}>100%</span>
                      <span className={styles.statLabel}>Satisfação</span>
                    </div>
                    <div className={styles.statItem}>
                      <span className={styles.statNumber}>+80%</span>
                      <span className={styles.statLabel}>Produtividade</span>
                    </div>
                    <div className={styles.statItem}>
                      <span className={styles.statNumber}>24/7</span>
                      <span className={styles.statLabel}>Suporte</span>
                    </div>
                  </div>
                </div>
                
                {/* Card 2 - Benefícios */}
                <div className={styles.beCronosCard}>
                  <div className={styles.cardIcon}>
                    <FaChartLine />
                  </div>
                  <h3>Vantagens Exclusivas</h3>
                  <ul className={styles.benefitsList}>
                    <li>
                      <div className={styles.benefitIcon}>
                        <FaCheck />
                      </div>
                      <span>Implementação ágil e descomplicada</span>
                    </li>
                    <li>
                      <div className={styles.benefitIcon}>
                        <FaCheck />
                      </div>
                      <span>Atendimento humanizado e profissional</span>
                    </li>
                    <li>
                      <div className={styles.benefitIcon}>
                        <FaCheck />
                      </div>
                      <span>Economize tempo com automação inteligente</span>
                    </li>
                    <li>
                      <div className={styles.benefitIcon}>
                        <FaCheck />
                      </div>
                      <span>Sem downloads – tudo online</span>
                    </li>
                    <li>
                      <div className={styles.benefitIcon}>
                        <FaCheck />
                      </div>
                      <span>Clientes agendam sem registro ou login</span>
                    </li>
                  </ul>
                </div>
                
                {/* Card 3 - CTA */}
                <div className={styles.beCronosCard}>
                  <div className={styles.cardIcon}>
                    <FaBolt />
                  </div>
                  <h3>Pronto para transformar seu tempo?</h3>
                  <p className={styles.ctaText}>
                    Comece agora e experimente gratuitamente por 7 dias todos os recursos premium
                  </p>
                  <button 
                    onClick={() => window.open('https://wa.me/+5579996440678?text=Olá!%20Gostaria%20de%20iniciar%20um%20teste%20gratuito%20com%20o%20melhor%20serviço%20de%20gerenciamento%20de%20agendamentos%20e%20automação.', '_blank')} 
                    className={styles.ctaButton}
                  >
                    <FaRocket className={styles.buttonIcon} />
                    INICIAR TESTE GRATUITO
                  </button>
                  <div className={styles.ctaExtra}>
                    <FaCheck className={styles.ctaCheck} /> 
                    <span>Sem compromisso • Cancelamento fácil • Suporte completo</span>
                  </div>
                  <div className={styles.testimonials}>
                    <div className={styles.quoteIcon}>❝</div>
                    <p className={styles.quote}>
                      "O tempo é o bem mais valioso que temos, e é o único que não podemos recuperar."
                    </p>
                    <p className={styles.author}>- Sócrates</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botão CTA e Scroll Indicator (mantido igual) */}
        <div className={styles.scrollIndicator}>
          <div className={styles.scrollLine} />
          <span>TRANSFORME SEU TEMPO COM AUTOMAÇÃO INTELIGENTE</span>
        </div>
        
        <div className={styles.scrollIndicator}>
          <div className={styles.scrollLine} />
          <span>SEJA CRONOS!</span>
        </div>
        <a 
          href="https://wa.me/+5579996440678?text=Olá!%20Quero%20ter%20o%20melhor%20sistema%20de%20gerenciamento%20de%20agendamentos%20e%20automação%20para%20otimizar%20minha%20operação.%20Como%20posso%20começar%20e%20garantir%20que%20estou%20escolhendo%20o%20melhor%20serviço?"
          target="_blank" 
          rel="noopener noreferrer"
          className={styles.whatsappButton}
        >
          <FaWhatsapp />
        </a>
      </div>
      
      {/* Rodapé */}
      <footer className={styles.footer}>
        <div id="rodape" className={styles.footerContent}>
          {/* Novos ícones de redes sociais */}
          <div className={styles.socialIcons}>
            <a 
              href="https://instagram.com/cronosagenda" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram className={styles.socialIcon} />
            </a>
            <a 
              href="https://youtube.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube className={styles.socialIcon} />
            </a>
          </div>
          
          <div className={styles.footerContact}>
            <FaEnvelope className={styles.footerIcon} />
            <span>contato@cronosagenda.com.br</span>
          </div>
          
          {/* Links do Rodapé */}
          <div className={styles.footerLinks}>
            <a href="/privacidade" className={styles.privacyLink}>
              Política de Privacidade
            </a>
          </div>
          
          {/* Informações Legais */}
          <div className={styles.footerLegal}>
            <div className={styles.cnpj}>
              CNPJ: 63.578.924/0001-90
            </div>
            <div className={styles.footerCopyright}>
              © {new Date().getFullYear()} Cronos Agenda - Um Produto <span className={styles.brandHighlight}>Cronos Sistemas</span>. Todos os direitos reservados.
            </div>
            <div className={styles.developerCredit}>
              Desenvolvido por <span className={styles.developerHighlight}>ruansk7</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CyberMonochrome;